import type { InferGetStaticPropsType } from 'next';

import { TrackPage } from '~/components/TrackEvent';
import BaseLayout from '~/layouts/BaseLayout';

export const getStaticProps = async () => {
  try {
    const res = await fetch(
      'https://market-api.cashnote.kr/api/common/partners/names',
      {
        credentials: 'include',
      },
    );

    if (!res.ok) {
      return { props: { partnerList: [] } };
    }

    const partnerList = (await res.json()) as string[];

    return {
      props: {
        partnerList,
      },
    };
  } catch {
    return { props: { partnerList: [] } };
  }
};

const PartnerListPage = ({
  partnerList,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  return (
    <BaseLayout title="파트너 리스트">
      <TrackPage page="캐시노트마켓/partners/list" />
      <ul className="my-12 flex list-none flex-col border border-02">
        {partnerList.map((partner) => (
          <li
            className="list-none border-b border-02 p-12 last:border-b-0"
            key={partner}
          >
            {partner}
          </li>
        ))}
      </ul>
    </BaseLayout>
  );
};

export default PartnerListPage;
